import { Pipe, PipeTransform, inject } from '@angular/core';

import { startWith, map } from 'rxjs/operators';

import { ILabelDescriptionView, IStatusItem, LabelTypeEnum } from '../../../../models/office-data.model';
import { OfficeStore } from '@pages/office/store/office.store';

@Pipe({
  name: 'asyncStatusFromLabelValue',
  standalone: true,
})
export class AsyncStatusFromLabelValuePipe implements PipeTransform {
  private officeStore = inject(OfficeStore);

  transform(value: string, labelDescriptionView: ILabelDescriptionView): unknown {
    return labelDescriptionView.control.valueChanges.pipe(
      startWith(labelDescriptionView.control?.value),
      map(value => {
        if (!value || !labelDescriptionView || labelDescriptionView.type !== LabelTypeEnum.Status) {
          return value;
        }
        const fieldStatusItems = this.officeStore.statusesMap$()?.filter(i => i.LabelFieldSeq === labelDescriptionView.seq);
        if (fieldStatusItems?.some(i => i.LabelFieldValue)) {
          const statusItem = fieldStatusItems.find(i => i.LabelFieldValue == value);
          return statusItem ? this.formatStatusText(statusItem, value) : null;
        } else if (fieldStatusItems?.length > 0) {
          return this.formatStatusText(fieldStatusItems[0], value);
        }
      })
    );
  }

  formatStatusText(statusItem: IStatusItem, labelValue: unknown): unknown {
    return statusItem.StatusPlaceholder
      ? statusItem.Status.replace(statusItem.StatusPlaceholder, labelValue.toString())
      : statusItem.Status;
  }
}
